import { render } from "./ContactUs.vue?vue&type=template&id=911c407a&scoped=true"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"

import "./ContactUs.vue?vue&type=style&index=0&id=911c407a&lang=scss&scoped=true"

import exportComponent from "G:\\ke-qi-dao\\code\\network\\fix-bug-uat\\qidao-official-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-911c407a"]])

export default __exports__